import PropTypes from 'prop-types';
import React from 'react';
import { getMinLocalDate } from '../../../../utils/dateUtils';
import PhaseType from 'types/phase';

const contact_customer = ({ event: {
  kind, data: { attempt, outcomes, due_at, communication_method },
} }) =>
  <div className={kind}>
    {attempt && <p>ATTEMPT #{attempt}</p>}
    {outcomes && outcomes.map((outcome, i) =>
      <p key={i}>{outcome.source} - {outcome.result.join(', ')}</p>, // eslint-disable-line react/no-array-index-key
    )}
    {due_at && <p>Due date updated to: {getMinLocalDate(due_at)}</p>}
    {communication_method && <p>Automatic communication method: {communication_method.toUpperCase() || 'N/A'}</p>}
  </div>;

contact_customer.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      outcomes: PropTypes.arrayOf(
        PropTypes.shape({
          source: PropTypes.string.isRequired,
          result: PropTypes.arrayOf(PropTypes.string).isRequired,
          ok_to_text: PropTypes.bool,
          reached: PropTypes.bool,
        }),
      ),
      attempt: PropTypes.number,
      due_at: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};

export {
  contact_customer,
  contact_customer as install_contact_customer,
  contact_customer as workorder_contact_customer,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/contact_customer.jsx